import { NgGameDefinition } from "../model/ng-game-definition";

interface NgGameList {
    categories: any; // usesless
    games: {
        instant: NgGameDefinition[];
    };
}

let gameList: NgGameDefinition[] = null;
let gameListReadyPromiseResolve: (value: NgGameDefinition[]) => void = null;

const loadGameList = () => {
    return new Promise((res) => {
        if (gameList) {
            res(gameList);
        } else {
            gameListReadyPromiseResolve = res;
            ng_fw.updateGamesList();
        }
    });
};

/**
 * Called by NG on game list ready
 */
const gameListReady = (list: NgGameList) => {
    gameList = list?.games?.instant || null;
    // NG sometimes fires game list updated, without our loadGameList being called
    // so in that case, promise is null
    if (gameListReadyPromiseResolve) {
        gameListReadyPromiseResolve(gameList);
    }
};

/**
 * Finds game by id in NG game list
 */
const getGameFromNgList = (id: number) => gameList.find((game) => game.id == id);

/**
 * Fetches game definition from NG by id
 */
const fetchNgGameDefinition = async (id: number): Promise<NgGameDefinition> => {
    await loadGameList();
    return getGameFromNgList(id);
};

export const useNgCasinoGameList = () => ({
    gameListReady,
    fetchNgGameDefinition,
});
